import { render } from "./GoalsBody.vue?vue&type=template&id=6873867f&scoped=true"
import script from "./GoalsBody.vue?vue&type=script&lang=js"
export * from "./GoalsBody.vue?vue&type=script&lang=js"

import "./GoalsBody.vue?vue&type=style&index=0&id=6873867f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6873867f"

export default script